import dashboard from './dashboard';
import search from './search';
import billing from './billing';
import history from './history';
import bulk from './bulk';
import manage from './manage';
// import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, search, billing, history, bulk, manage]
};

export default menuItems;
